"use client";
import React, { useEffect } from "react";
import Image from "next/image";
import { useRouter } from "@/i18n/routing";
import { ButtonComponent, SnackbarComponent } from "@/components";
import { Stack, Typography } from "@mui/material";
import {
  GET_PRODUCT_APPLICATION,
  IMAGES,
  PRODUCTS,
  PRODUCT_HANDLER,
  STAGE,
  STAGE_BASED_ROUTING,
  WEB_COLORS,
  WEB_EVENTS,
  errorValidator,
} from "@/lib/constants";
import { useGetApplicationQuery, useGetCustomerQuery } from "@/lib/redux";
import useLogoutHook from "@/lib/hooks/logoutHook";
import useErrorHandling from "@/lib/hooks/errorhandling";
import { sendEventAnalytics } from "@/lib/hooks/eventAnalytics";

const FinalEsignScreen = ({ product }) => {
  const router = useRouter();
  // fetch application data from get api
  const { data: applicationData, error: errorGetApplication } =
    useGetApplicationQuery();
  const { data: customerData } = useGetCustomerQuery();
  const productApplication = GET_PRODUCT_APPLICATION(
    PRODUCT_HANDLER[product],
    applicationData?.data
  );
  const isError = errorGetApplication;

  /***************************************EFFECT************************************ */
  useErrorHandling(isError);

  /***************************************RENDER************************************ */
  return (
    <>
      <Stack alignItems={"center"} rowGap={2} spacing={2} p={2} my={2} mx={5}>
        <Image
          src={IMAGES.congratulations}
          height={200}
          alt="congratulations"
        />
        <div align="center">
          <Typography fontSize={20}>Congratulations!</Typography>
          <Typography fontSize={16} color={"#4D6767"}>
            {productApplication?.stage === "BRE_CPV_TVR"
              ? "Your loan has been sanctioned!"
              : "Your loan has been approved!"}
          </Typography>
        </div>
        <Typography align="center" color={WEB_COLORS.textFadeColor}>
          {" We'll "}send you the loan details via email, soon. Along with,{" "}
          {"you'll "}
          receive the tentative date & time on which your amount will be
          credited.
        </Typography>
        <Stack mt={6}>
          <Typography align="center">
            {/* {"Note: We'll process your funds soon."} */}
            {productApplication?.stage === STAGE?.BRE_CPV_TVR
              ? (productApplication?.stage === STAGE?.BRE_CPV_TVR &&
                  eSignData?.data?.cpvAction === "Waiver") ||
                (productApplication?.stage === STAGE?.LMS_ONBOARDING &&
                  eSignData?.data?.cpvAction === "Waiver")
                ? "Your loan is conditionally approved & pending for telephonic verification. Telephonic verification will be completed within 1 working day."
                : "Your loan is conditionally approved & pending for physical verification. Physical verification will be completed within 2 working days."
              : "Note: You loan application has already been approved but your loan application is pending for disbursement."}
          </Typography>
        </Stack>
        <ButtonComponent
          type="submit"
          onClick={() => {
            router.push("/"); //navigate to login screen
          }}
          buttonStyle={{
            width: "40%",
            borderRadius: "8px",
          }}
        >
          Go to Homepage
        </ButtonComponent>
      </Stack>
    </>
  );
};

export default FinalEsignScreen;
